import { useMemo } from 'react';
import { DayOfTheWeekRange } from 'cron-parser/types';

import { globalTranslation, useTranslation } from 'modules/i18n';

type UseWeekDaysOptionsResult = { id: DayOfTheWeekRange; name: string }[];

const DAY_NUMBERS: DayOfTheWeekRange[] = [1, 2, 3, 4, 5, 6, 0];

export function useWeekDaysOptions(): UseWeekDaysOptionsResult {
  const { t, keys } = useTranslation(globalTranslation);

  return useMemo(() => {
    return DAY_NUMBERS.map(id => {
      const date = new Date();
      return {
        id,
        name: t(keys.units.fullDay, {
          date: date.setDate(date.getDate() - (date.getDay() - id)),
        }),
      };
    });
  }, [t, keys]);
}
